import ProductList from './productlist';
import CartProvider from 'shared/context/cart';

const Products = () => {
  return <ProductList />;
};

export default Products;
